import { isInstanceOf } from "@pzapalski/ts-utils/dist/guards/is-instance-of";
import { always } from "asrt";
export function tabsController(container) {
    always(isInstanceOf(HTMLElement, container), "[KzT-rMx-pwW]");
    const tabs = container.querySelectorAll('[data-element=Tab]');
    const containers = document.querySelectorAll('[data-element=TabContainer]');
    console.log(tabs, containers);
    /**
     * on click of a tab > button, show the corresponding container
     * */
    tabs.forEach((tab, i) => {
        always(isInstanceOf(HTMLElement, tab), "[Pc3-7E7-z3t]");
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const target = tab.getAttribute('data-target');
            const targetElement = document.getElementById('TabContainer_' + target);
            const button = tab.querySelector('button');
            console.log(target, targetElement);
            always(isInstanceOf(HTMLElement, targetElement), "[Fsj-7DM-exT]");
            tabs.forEach(t => {
                const b = t.querySelector('button');
                b === null || b === void 0 ? void 0 : b.classList.remove('active');
            });
            containers.forEach(c => c.classList.remove('active'));
            button === null || button === void 0 ? void 0 : button.classList.add('active');
            targetElement.classList.add('active');
        });
    });
}
